import React, { forwardRef } from 'react';
import OutsideClickHandler from 'react-outside-click-handler';

import { TextInput } from 'components/uikit/Form/TextInput/TextInput';
import { TextInputMasked } from 'components/uikit/Form/TextInputMasked/TextInputMasked';
import { DropDown } from 'components/uikit/DropDown/DropDown';
import { useDaDataPresenter } from './DaDataUiKit.presenter';
import * as S from './DaDataUiKit.styles';

const fn = () => {};
export const DaDataUiKit = forwardRef((props, ref) => {
  const {
    type = 'address',
    name,
    additionalData,
    theme = 1,
    value = '',
    resultsCount = 20,
    onChange = fn,
    onBlur = fn,
    debounce = 500,
    mask = null,
    className,
    ...rest
  } = props;
  const presenter = useDaDataPresenter({
    value,
    type,
    name,
    additionalData,
    onChange,
    onBlur,
    resultsCount,
    debounce,
    mask,
  });
  const Input = mask ? TextInputMasked : TextInput;

  return (
    <S.Container className={className} ref={ref}>
      <OutsideClickHandler onOutsideClick={presenter.outsideClickHandler}>
        <Input
          {...rest}
          value={presenter.localValue}
          mask={mask}
          onChange={presenter.changeHandler}
          onBlur={presenter.blurHandler}
          theme={theme}
          wrapperRef={presenter.inputRef}
        />

        {presenter.isDropDownShown && (
          <DropDown ref={presenter.dropDownRef} targetRef={presenter.inputRef} gap={10}>
            <S.DropDownContainer theme={theme}>
              {presenter.suggestions.map((item, index) => (
                <S.ListItemStyled
                  size="m"
                  gap={8}
                  key={`${item.value}-${index}`}
                  title={item.value}
                  onClick={() => presenter.suggestionClickHandler(item)}
                />
              ))}
            </S.DropDownContainer>
          </DropDown>
        )}
      </OutsideClickHandler>
    </S.Container>
  );
});

DaDataUiKit.displayName = 'DaDataUiKit';
